/* eslint-disable max-len */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { InfoWindow } from 'react-google-maps'
import { Link } from 'react-router'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import getPath from '../../../shared/utils/getPath'
import Icon from '../../../shared/components/Icon'

@observer
export default class Info extends Component {

  static propTypes = {
    marker: PropTypes.object,
    museum: PropTypes.object,
    onClose: PropTypes.func,
  }

  // constructor(props) {
  //   super(props)
  //   // props.museum.loadOffers()
  // }

  @autobind
  handleClose() {
    if (this.props.onClose) {
      this.props.onClose(this.props.marker)
    }
  }

  renderOffersList(museum) {

    // if (
    //   (!museum.programs.length && museum.programsLoading) ||
    //   (!museum.guidedTours.length && museum.guidedToursLoading)
    // ) {
    //   return <Loader>Angebote werden geladen</Loader>
    // }

    const offers = [
      ...toJS(museum.programs).map((m) => ({ ...m, type: 'program' })),
      ...toJS(museum.guidedTours).map((m) => ({ ...m, type: 'guidedTour' })),
    ]
    // only show those offers, that match the current filters
    // .map(offer => !!offer.isInFilters)

    if (!offers.length) {
      return <span>Keine Angebote gefunden</span>
    }

    return (
      <ul className="list-unstyled">
        {
          offers
            .map((offer) => (
              <li
                key={`${offer.type}-${offer.id}`}
              >
                <Link to={getPath('frontend', offer.type, offer.id)} className={offer.temporarilyNotBookable ? 'faded' : ''}>
                  {offer.title}
                  {' '}
                  {offer.temporarilyNotBookable ? (<Icon className="inline" name="virus-turquoise" title={offer.temporarilyNotBookableReason} />) : null}

                </Link>
              </li>
            ))
        }
      </ul>
    )

  }

  render() {

    const { museum } = this.props

    return (
      <InfoWindow
        onCloseClick={this.handleClose}
      >
        <div>
          <h2>Gefundene Angebote</h2>
          {this.renderOffersList(museum)}
          <div>
            <div>{museum.name}</div>
            <small className="text-muted">
              {
                museum.address.street
              }
              {
                museum.address.number
              }
&nbsp;∙&nbsp;
              {
                museum.address.zip
              }
              {
                museum.address.location
              }
            </small>
          </div>
        </div>
      </InfoWindow>
    )

  }

}



// WEBPACK FOOTER //
// ./src/frontend/map/components/Info.js